// Components==============
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './RadioCircle.module.scss';
// =========================

export default function RadioCircle({
    isSelected,
    background,
    opacity,
    onClick,
    label,
}) {
    return (
        <div styleName="wrapper" onClick={onClick}>
            <div
                styleName="radio "
                style={{
                    backgroundColor: background || '#F1F0EA',
                    opacity: opacity ? 0.4 : 1,
                }}
            >
                <FontAwesomeIcon
                    icon={faCircle}
                    style={{
                        color: isSelected
                            ? opacity
                                ? '#fff'
                                : '#1e265c'
                            : background || '#F1F0EA',
                    }}
                />
            </div>
            {label && <p>{label}</p>}
        </div>
    );
}
